import Cookies from "js-cookie";
import { nanoid } from "nanoid";

export const setAccessToken = (token, refreshToken) => {
  Cookies.set("authtoken", token);
  if (refreshToken) {
    Cookies.set("refreshToken", refreshToken);
  }
};

export const getAccessToken = () => {
  let token = Cookies.get("authtoken");
  return token || "";
};

export const setGuestToken = (token, refreshToken) => {
  Cookies.set("guestToken", token);
  if (refreshToken) {
    Cookies.set("guestRefreshToken", refreshToken);
  }
};

export const getGuestToken = () => {
  let token = Cookies.get("guestToken");
  return token || "";
};

export const getRefreshToken = () => {
  let token = Cookies.get("refreshToken");
  return token || "";
};

export const getGuestRefreshToken = () => {
  let token = Cookies.get("guestRefreshToken");
  return token || "";
};

export const removeAccessToken = () => {
  Cookies.remove("authtoken");
  Cookies.remove("refreshToken");
};

export const removeGuestToken = () => {
  Cookies.remove("guestToken");
  Cookies.remove("guestRefreshToken");
};

export function getOrCreateSignifydSessionId() {
  if (typeof window === "undefined") return "";

  let sessionId = sessionStorage.getItem("signifyd_session_id");
  if (!sessionId) {
    sessionId =
      typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : nanoid();

    sessionStorage.setItem("signifyd_session_id", sessionId);
  }

  return sessionId ?? "";
}
